import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes, FaEye } from 'react-icons/fa';
import noteBlankIcon from '../../assets/icons/note-blank.svg';
import userIcon from '../../assets/icons/user-icon.svg';
import calendarDotsIcon from '../../assets/icons/calendar-dots.svg';
import shareFatIcon from '../../assets/icons/share-fat-alt.svg';
import { useI18n } from '../../i18n';
import '../Projects/ProjectComposer.css';
import './NotesSection.css';
import './NoteViewModalRedesign.css';

const NoteViewModal = ({ isOpen, note, onClose }) => {
    const { locale, t } = useI18n();
    if (!isOpen || !note) return null;

    const formatDate = (dateString) => {
        if (!dateString) return t('common.misc.na');
        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) return t('common.misc.na');
        const localeCode = locale === 'en' ? 'en-GB' : locale;

        return new Intl.DateTimeFormat(localeCode, {
            dateStyle: 'medium',
            timeStyle: 'short',
        }).format(date);
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const sharedUsers = note.shared_users || [];
    const sharedUserNames = sharedUsers.map(user => user.name).join(', ');

    return ReactDOM.createPortal(
        <div className="project-composer-overlay" onClick={handleBackdropClick}>
            <div className="project-composer-modal note-view-modal-redesign">
                <div className="project-composer-header">
                    <h2 className="project-composer-title">
                        <FaEye style={{ marginRight: '8px' }} />
                        {t('pages.file_manager.notes.view.title')}
                    </h2>
                    <button
                        className="project-composer-close"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <FaTimes />
                    </button>
                </div>

                <div className="project-composer-body note-view-body-redesign">
                    {/* Note Title Section */}
                    <div className="nv-redesign-row">
                        <div className="nv-redesign-label">
                            <img src={noteBlankIcon} alt="" width={20} height={20} />
                            <span>{t('pages.file_manager.notes.view.note_title')}</span>
                        </div>
                        <div className="nv-redesign-value">
                            {note.title || t('pages.file_manager.notes.view.untitled')}
                        </div>
                    </div>

                    {/* Note Content Box */}

                    <div className="nv-redesign-content-box">
                        {note.content || t('pages.file_manager.notes.view.no_content')}
                    </div>
                    <div className='view-border-bottom'> </div>

                    {/* Owner Section */}
                    <div className="nv-redesign-row nv-info-row">
                        <div className="nv-redesign-label nv-info-label">
                            <img src={userIcon} alt="" width={20} height={20} />
                            <span>{t('pages.file_manager.notes.view.owner')}</span>
                        </div>
                        <div className="nv-redesign-value nv-info-value">
                            {note.owner?.name || t('pages.file_manager.notes.view.unknown')}
                        </div>
                    </div>

                    {/* Date & Time Section */}
                    <div className="nv-redesign-row nv-info-row">
                        <div className="nv-redesign-label nv-info-label">
                            <img src={calendarDotsIcon} alt="" width={20} height={20} />
                            <span>{t('pages.file_manager.notes.view.date_time')}</span>
                        </div>
                        <div className="nv-redesign-value nv-info-value">
                            {formatDate(note.created_at)}
                        </div>
                    </div>

                    {/* Shared With Section */}
                    <div className="nv-redesign-row nv-info-row">
                        <div className="nv-redesign-label nv-info-label">
                            <img src={shareFatIcon} alt="" width={20} height={20} />
                            <span>{t('pages.file_manager.notes.view.shared_with', { count: sharedUsers.length })}</span>
                        </div>
                        <div className="nv-redesign-value nv-info-value">
                            {sharedUserNames || t('pages.file_manager.notes.view.not_shared')}
                        </div>
                    </div>

                    {/* Tags Section */}
                    {note.tags && note.tags.length > 0 && (
                        <div className="nv-redesign-tags-section">
                            <div className="nv-redesign-tags-label">{t('pages.file_manager.notes.view.tags')}</div>
                            <div className="nv-redesign-tags">
                                {note.tags.map((tag, index) => (
                                    <span key={tag.id || tag.slug || index} className="nv-redesign-tag">
                                        {tag.name || tag}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="project-composer-footer">
                    <button
                        type="button"
                        className="project-composer-btn project-composer-btn-secondary"
                        onClick={onClose}
                    >
                        {t('common.actions.close')}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default NoteViewModal;
